import { useState, useEffect } from 'react'
import UsersChatsList from './UsersChatsList'
import UserChatView from './UserChatView'
import Footer from '../Footer/Footer'
import { Button, Offcanvas } from 'react-bootstrap'
import { useSearchParams } from 'react-router-dom'
import TicketInfo from './TicketInfo'

const Conversations = () => {
  const [searchParams, setSearchParams] = useSearchParams({ chatId: '' })
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 991)
  const [show, setShow] = useState(false)

  console.log(searchParams)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 991)
    }

    window.addEventListener('resize', handleResize)

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const chatId = searchParams.get('chatId')
  console.log(chatId)
  return (
    <>
      <div id="appCapsule">
        <div className="section full">
          <div className="row">
            <div
              className={`col-12 ${
                chatId === '' ? '' : 'd-none'
              } d-sm-block col-sm-5 col-md-4 col-lg-3 bg-light px-0`}
              style={{ borderRight: '2px #eee solid' }}
            >
              <UsersChatsList />
              {/* <Footer /> */}
            </div>
            <div
              className={`col-12 ${
                chatId === '' ? 'd-none' : ''
              } col-sm-7 col-md-8 col-lg-6 px-0`}
            >
              <UserChatView handleShow={handleShow} />
            </div>
            <div
              className={`col-12 ${
                chatId === ''
                  ? 'd-none'
                  : isLargeScreen
                  ? 'd-lg-block'
                  : 'd-none'
              }  d-none col-sm-7 col-md-4 col-lg-3 bg-white px-0`}
            >
              {isLargeScreen && (
                <TicketInfo
                  handleClose={handleClose}
                  isLargeScreen={isLargeScreen}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <Button variant="primary" onClick={handleShow} className="me-2"></Button> */}
      {!isLargeScreen && (
        <Offcanvas
          show={show}
          onHide={handleClose}
          placement="end"
          name="end"
          className="w-100"
        >
          <Offcanvas.Header className="off-header p-0">
            <ul class="nav nav-tabs lined" role="tablist">
              <button
                onClick={handleClose}
                className="bg-transparent border-0"
                style={{ position: 'absolute', width: '55px', height: '55px' }}
              >
                <ion-icon
                  name="chevron-back-outline"
                  style={{ position: 'absolute', top: '20px' }}
                ></ion-icon>
              </button>
              <li class="nav-item">
                <a
                  class="nav-link active"
                  data-bs-toggle="tab"
                  href="#example1a"
                  role="tab"
                >
                  <ion-icon name="information-circle-outline"></ion-icon>
                  Infomation
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  data-bs-toggle="tab"
                  href="#example2a"
                  role="tab"
                >
                  <ion-icon name="hourglass-outline"></ion-icon>
                  TimeLine
                </a>
              </li>
            </ul>
            {/* <Offcanvas.Title>Offcanvas</Offcanvas.Title> */}
          </Offcanvas.Header>

          <Offcanvas.Body className="p-0">
            <TicketInfo handleClose={handleClose} />
          </Offcanvas.Body>
        </Offcanvas>
      )}
      <div
        class="offcanvas offcanvas-bottom action-sheet inset"
        tabIndex="-1"
        id="actionSheetAdd"
      >
        <div class="offcanvas-header">
          <h5 class="offcanvas-title">Share</h5>
        </div>
        <div class="offcanvas-body">
          <ul class="action-button-list">
            <li>
              <a href="#" class="btn btn-list" data-bs-dismiss="offcanvas">
                <span>
                  <ion-icon name="camera-outline"></ion-icon>
                  Take a photo
                </span>
              </a>
            </li>
            <li>
              <a href="#" class="btn btn-list" data-bs-dismiss="offcanvas">
                <span>
                  <ion-icon name="videocam-outline"></ion-icon>
                  Video
                </span>
              </a>
            </li>
            <li>
              <a href="#" class="btn btn-list" data-bs-dismiss="offcanvas">
                <span>
                  <ion-icon name="image-outline"></ion-icon>
                  Upload from Gallery
                </span>
              </a>
            </li>
            <li>
              <a href="#" class="btn btn-list" data-bs-dismiss="offcanvas">
                <span>
                  <ion-icon name="document-outline"></ion-icon>
                  Documents
                </span>
              </a>
            </li>
            <li>
              <a href="#" class="btn btn-list" data-bs-dismiss="offcanvas">
                <span>
                  <ion-icon name="musical-notes-outline"></ion-icon>
                  Sound file
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}

export default Conversations
